import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const DropdownOptionRecord = Record({
  label: "",
  value: "",
  displayId: "",
  color: "",
  icon: "",
  selected: false,
  disabled: false,
  description: ""
});

createFromJS.registerCallback("DropdownOptionRecord", createFromJS.createPrimitiveCallback(DropdownOptionRecord));
